<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">{{ $t('shiftManagement.showDetails') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <div class="row">
        <div class="col-md-12">
          <div id="container-table">
            <table class="table ui-table table-hover">
              <thead>
                <tr>
                  <th style="width:10%">
                    {{ $t('shiftManagement.keyword') }}
                  </th>
                  <th>
                    {{ $t('shiftManagement.fromDay') }}
                  </th>
                  <th>
                    {{ $t('shiftManagement.toDay') }}
                  </th>
                  <th style="width:12%">
                    {{ $t('shiftManagement.firstIn') }}
                  </th>
                  <th style="width:12%">
                    {{ $t('shiftManagement.firstOut') }}
                  </th>
                  <th style="width:12%">
                    {{ $t('shiftManagement.secondIn') }}
                  </th>
                  <th style="width:12%">
                    {{ $t('shiftManagement.secondOut') }}
                  </th>
                  <th style="width:20%">
                    {{ $t('shiftManagement.TotalHours') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in model.details" :key="index">
                  <td>
                    <ts-input type="text" v-model="item.keyword" class="form-control-plaintext" />
                  </td>
                  <td>
                    <ts-select
                      v-model="item.day_id_from"
                      class="form-control-plaintext"
                      :options="
                        weekDays.map(e => ({
                          text: e.day_name,
                          value: e.day_id
                        }))
                      "
                    />
                  </td>
                  <td>
                    <ts-select
                      v-model="item.day_id_to"
                      class="form-control-plaintext"
                      :options="
                        weekDays.map(e => ({
                          text: e.day_name,
                          value: e.day_id
                        }))
                      "
                    />
                  </td>
                  <td>
                    <ts-input v-model="item.first_in" class="form-control-plaintext" />
                  </td>
                  <td>
                    <ts-input v-model="item.first_out" class="form-control-plaintext" />
                  </td>
                  <td>
                    <ts-input v-model="item.second_in" class="form-control-plaintext" />
                  </td>
                  <td>
                    <ts-input v-model="item.second_out" class="form-control-plaintext" />
                  </td>
                  <td>
                    <input :value="totalHour(item).description" class="form-control-plaintext" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'shift-management-show',
  props: ['showData'],
  data() {
    return {
      model: {
        shift_name: '',
        shift_type: null,
        minute_allow: '',
        details: []
      },
      weekDays: [
        {
          day_id: 1,
          day_name: 'Monday'
        },
        {
          day_id: 2,
          day_name: 'Tuesday'
        },
        {
          day_id: 3,
          day_name: 'Wednesday'
        },
        {
          day_id: 4,
          day_name: 'Thursday'
        },
        {
          day_id: 5,
          day_name: 'Friday'
        },
        {
          day_id: 6,
          day_name: 'Saturday'
        },
        {
          day_id: 7,
          day_name: 'Sunday'
        }
      ]
    }
  },
  created() {
    this.setShowData()
  },
  computed: {
    ...mapGetters('hr/shiftManagement', ['totalHour', 'tConvert'])
  },
  methods: {
    setShowData() {
      if (!_.isEmpty(this.showData)) {
        this.model = {
          shift_name: this.showData.shift_name,
          shift_type: this.showData.shift_type,
          minute_allow: this.showData.minute_allow,
          details: []
        }
        this.showData.details.map(el => {
          this.model.details.push({
            keyword: el.keyword,
            day_id_from: el.day_id_from,
            day_id_to: el.day_id_to,
            first_in: this.tConvert(el.first_in),
            first_out: this.tConvert(el.first_out),
            second_in: this.tConvert(el.second_in),
            second_out: this.tConvert(el.second_out),
            total_hour: el.total_hour
          })
        })
      }
    }
  }
}
</script>
<style lang="css" scoped>
/* This is to remove the arrow of select element in IE */
  select::-ms-expand {	display: none; }
  select{
      -webkit-appearance: none;
      appearance: none;
  }
</style>
